import { Box, Grid, IconButton, Paper } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Formik } from "formik";
import React from "react";
import { Link, useHistory } from "react-router-dom";

import { Center } from "../../../../components/center";
import { DateInput } from "../../../../components/date_input";
import { ROUTES } from "../../../../routes";
import {
  IProductHistoryFilter,
  productHistoryFilterToQueryParams,
  productHistoryQueryParamsToFilter,
} from "../../data/filter";

interface IProps {}

const todayDate = new Date();
const initialFilter: IProductHistoryFilter = {
  createdDate: todayDate,
};

export const ProductHistoryFilter: React.FC<IProps> = () => {
  const history = useHistory();

  function onSubmit(values: IProductHistoryFilter) {
    history.push({
      search: productHistoryFilterToQueryParams(values),
    });
  }

  const initialValues = history.location.search
    ? productHistoryQueryParamsToFilter(history.location.search)
    : initialFilter;

  return (
    <Formik<IProductHistoryFilter> initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
      {({ submitForm, setFieldValue }) => {
        return (
          <Paper>
            <Box px={2}>
              <Grid container spacing={2} alignItems="flex-end">
                <Grid item xs={6} sm={4} md={2}>
                  <DateInput
                    label="Tarix"
                    name="createdDate"
                    maxDate={initialFilter.createdDate}
                    onChange={() => {
                      submitForm();
                    }}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                <Grid item sm={1}>
                  <Center>
                    <IconButton to={ROUTES.productHistory} component={Link}>
                      <CloseIcon />
                    </IconButton>
                  </Center>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        );
      }}
    </Formik>
  );
};
